import React from 'react';
import PropTypes from 'prop-types';

import { NoData, AlertDialog, toast, Loading } from '@meronex/components';

import IEdit from '@meronex/icons/fi/FiEdit2';
import IDelete from '@meronex/icons/fi/FiTrash2';

import { useTheme } from '@material-ui/core/styles';
import { storeCategoriesMng } from '../api/storeCategoriesMng';

const StoreCategoryItem = (props) => {
  const { onEdit, onDelete, storeCategory } = props;
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [hovered, setHovered] = React.useState(false);

  const textColor = isDark ? '#e2e8f0' : '#0f172a';
  const borderColor = isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9';
  const hoverBg = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc';

  return (
    <div
      onClick={() => onEdit(storeCategory)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '12px 16px',
        borderBottom: `1px solid ${borderColor}`,
        cursor: 'pointer',
        backgroundColor: hovered ? hoverBg : 'transparent',
        transition: 'background-color 0.15s',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{
          fontSize: '14px',
          fontWeight: 600,
          color: textColor,
        }}>
          {storeCategory.name}
        </span>
      </div>
      <div style={{
        display: 'flex',
        gap: '4px',
        flexShrink: 0,
        opacity: hovered ? 1 : 0.3,
        transition: 'opacity 0.15s',
      }}>
        <div
          onClick={(e) => { e.stopPropagation(); onEdit(storeCategory); }}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6366f1',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(99,102,241,0.15)' : '#eef2ff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IEdit size={15} />
        </div>
        <div
          onClick={(e) => { e.stopPropagation(); onDelete(storeCategory); }}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: isDark ? '#f87171' : '#dc2626',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(248,113,113,0.1)' : '#fef2f2'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IDelete size={15} />
        </div>
      </div>
    </div>
  );
};

function StoreCategoriesList(props) {
  const { storeCategories, onEdit, onDelete } = props;

  const [deleting, setDeleting] = React.useState();
  const [openDeleteAlert, setOpenDeleteAlert] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState();

  const _onDelete = (storeCategory) => {
    setOpenDeleteAlert(true);
    setSelectedItem(storeCategory);
  };

  const onConfirmDelete = async () => {
    setDeleting(true);
    setOpenDeleteAlert(false);
    try {
      await storeCategoriesMng.deleteStoreCategory(selectedItem);
      toast.success('Store category successfully deleted');
      onDelete();
    } catch (e) {
      toast.error(e.reason);
    } finally {
      setDeleting(false);
    }
  };

  const renderStoreCategories = () => {
    if (!Array.isArray(storeCategories)) {
      return <Loading />;
    } else if (storeCategories.length === 0) {
      return <NoData type={'warn'} />;
    }

    return storeCategories.map((storeCategory) => (
      <StoreCategoryItem
        key={storeCategory._id}
        storeCategory={storeCategory}
        onEdit={onEdit}
        onDelete={_onDelete}
      />
    ));
  };

  return (
    <>
      <div>{renderStoreCategories()}</div>
      <AlertDialog
        open={openDeleteAlert}
        loading={deleting}
        onClose={() => { setOpenDeleteAlert(false); }}
        onConfirm={onConfirmDelete}
      />
    </>
  );
}
StoreCategoriesList.propTypes = {
  storeCategories: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

StoreCategoriesList.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};
export default StoreCategoriesList;
